import Link from '@mui/material/Link';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

type NameProps = {
  year: number;
  make: string;
  model: string;
  trim: string;
  stockNumber: string;
};

const StyledLink = styled(Link)(({ theme }) => ({
  color: theme.palette.text.primary,

  '&:visited': {
    color: theme.palette.flagged.dark,
  },

  '.kmx-car-tile--unavailable &': {
    color: theme.palette.text.disabled,
  },
}));

const Name = ({ year, make, model, trim, stockNumber }: NameProps) => {
  return (
    <Typography className="kmx-car-tile__make-model-link" component="h3" noWrap>
      <StyledLink href={`/car/${stockNumber}`} rel="nofollow" underline="none">
        {year} {make} {model} {trim}
      </StyledLink>
    </Typography>
  );
};

export default Name;
